import { render } from "./weekly.vue?vue&type=template&id=e31b2bf2"
import script from "./weekly.vue?vue&type=script&lang=js"
export * from "./weekly.vue?vue&type=script&lang=js"

import "./weekly.vue?vue&type=style&index=0&id=e31b2bf2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__